// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"acf3e452","601":"e6a92492","787":"1c863b1e"}[chunkId] + ".chunk.js";
};